import React from 'react'
import MaterialSymbol from '../material-symbol'

const EventAvailable = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="event_available" {...props} />
))

EventAvailable.displayName = 'EventAvailable'

export default EventAvailable
